import { component } from 'picoapp';
import { TimelineMax } from 'gsap/all';
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
// import anime from 'animejs';

class CollectionFilters {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.isOpen = false;
    this.init(el);
    this.initAnimation();
    this.bindEvents();
  }

  init(el) {
    this.el = el;
    this.inner = el.querySelector('inner');
    // this.menuOptions = el.querySelectorAll('.Nav__item--level1');
    this.header = el.querySelector('header');
    // this.footer = el.querySelector('footer');
    // this.mobileNav = el.querySelector('.Nav--mainMobile');
  }

  initAnimation() {
    const tl = new TimelineMax({
      onComplete: () => {
        document.body.classList.add('has-modalOpen');
        this.isOpen = true;
      },
      onReverseComplete: () => {
        this.isOpen = false;
        document.body.classList.remove('has-modalOpen');
      }
    });

    tl.set(this.el, { display: 'block', immediateRender: false });
    tl.from(this.el, 0.2, { opacity: 0 });
    // tl.staggerFrom(this.menuOptions, 0.4, { y: '10%', autoAlpha: 0, ease: Power4.easeOut }, 0.06);
    tl.from(this.header, 0.2, { y: '7%', autoAlpha: 0, ease: Power4.easeOut });
    // tl.from(this.footer, 0.2, { y: '7%', autoAlpha: 0, ease: Power4.easeOut });
    tl.pause();

    this.tl = tl;
  }

  bindEvents() {
    this.ctx.on('toggle', (state) => {
      if (state.identifier == this.identifier) {
        this.toggle();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.tl.timeScale(1);
    if (this.isOpen) {
      return;
    }
    this.tl.play();
    disableBodyScroll(this.inner);
  }

  close() {
    this.tl.timeScale(1.3);
    if (!this.isOpen) {
      return;
    }
    this.tl.reverse();
    enableBodyScroll(this.inner);
  }
}

export default component((node, ctx) => {
  new CollectionFilters(node, ctx);
});
